<form class="login-form-sso" method="POST" action="/functions/sign-in/handle-password-login">
    <div class="form-group col-12 col-lg-12">
        <label for="exampleInputText1" class="">Email</label>
        <input type="email" class="form-control" id="email" name="email" placeholder="Email" value="{{email}}">
    </div>

    <div class="form-group col-12 col-lg-12">
        <label for="password" class="">Password</label>
        <input type="password" class="form-control" id="password" name="password" placeholder="Password">
    </div>
    <div class="col-12 form-group">
        <a class="password-reset" href="/resetpassword/">Forgot your password?</a>
    </div>
    <div class="col-12">
        <button type="submit" class="btn btn-primary  btn-block sign-in hotjar-ignore" name="submit-signin" id="sign-in-button">Login</button>
        <a class="text-center btn btn-link btn-block text-blue-800" href="#" id="switch-login-to-sso">Use Single Sign-On</a>
    </div>
</form>